import { makeConstantFactory } from 'utils/constantsHelper'
const makeConstant = makeConstantFactory('conversation')

export const FETCH_CONVERSATION = makeConstant('FETCH_CONVERSATION')
export const FETCH_CONVERSATION_PENDING = makeConstant('FETCH_CONVERSATION_PENDING')
export const FETCH_CONVERSATION_FAILED = makeConstant('FETCH_CONVERSATION_FAILED')
export const FETCH_CONVERSATION_CANCELLED = makeConstant('FETCH_CONVERSATION_CANCELLED')

export const PATCH_CONVERSATION = makeConstant('PATCH_CONVERSATION')
export const PATCH_CONVERSATION_PENDING = makeConstant('PATCH_CONVERSATION_PENDING')
export const PATCH_CONVERSATION_FAILED = makeConstant('PATCH_CONVERSATION_FAILED')
export const PATCH_CONVERSATION_CANCELLED = makeConstant('PATCH_CONVERSATION_CANCELLED')

export const SET_PLAYBOOK_ID_FOR_CONVERSATION = makeConstant('SET_PLAYBOOK_ID_FOR_CONVERSATION')

export const FETCH_CONVERSATION_LIST = makeConstant('FETCH_CONVERSATION_LIST')
export const FETCH_CONVERSATION_LIST_PENDING = makeConstant('FETCH_CONVERSATION_LIST_PENDING')
export const FETCH_CONVERSATION_LIST_CANCELLED = makeConstant('FETCH_CONVERSATION_LIST_CANCELLED')
export const FETCH_CONVERSATION_LIST_FAILED = makeConstant('FETCH_CONVERSATION_LIST_FAILED')
export const FETCH_CONVERSATION_LIST_SUCCESS = makeConstant('FETCH_CONVERSATION_LIST_SUCCESS')
export const FETCH_NEXT_CONVERSATION_LIST = makeConstant('FETCH_NEXT_CONVERSATION_LIST')
export const FETCH_NEXT_CONVERSATION_LIST_SUCCESS = makeConstant('FETCH_NEXT_CONVERSATION_LIST_SUCCESS')

export const FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID')
export const FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_PENDING')
export const FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_FAILED')
export const FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS = makeConstant('FETCH_CONVERSATIONS_COUNT_FOR_END_USER_ID_SUCCESS')

export const FETCH_CONVERSATIONS_FOR_END_USER = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER')
export const FETCH_CONVERSATIONS_FOR_END_USER_PENDING = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER_PENDING')
export const FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER_SUCCESS')
export const FETCH_CONVERSATIONS_FOR_END_USER_FAILURE = makeConstant('FETCH_CONVERSATIONS_FOR_END_USER_FAILURE')

export const CREATE_CONVERSATION = makeConstant('CREATE_CONVERSATION')
export const CREATE_CONVERSATION_PENDING = makeConstant('CREATE_CONVERSATION_PENDING')
export const CREATE_CONVERSATION_FAILED = makeConstant('CREATE_CONVERSATION_FAILED')

export const RECEIVE_CONVERSATION = makeConstant('RECEIVE_CONVERSATION')

export const SET_ACTIVE_CONVERSATION = makeConstant('SET_CURRENT_CONVERSATION')
export const UNSET_ACTIVE_CONVERSATION = makeConstant('UNSET_ACTIVE_CONVERSATION')
export const ConversationStatus = Object.freeze({
  OPEN: 'OPEN',
  PENDING: 'PENDING',
  CLOSED: 'CLOSED',
})

export const SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX = makeConstant('SET_ACTIVE_CONVERSATION_CONTACT_TAB_INDEX')

export const CONVERSATION_CHANGED = makeConstant('CONVERSATION_CHANGED')
export const CONVERSATIONS_REGEX = /inboxes\/(\d+)\/conversations\/?(\d+)?/

export const SEND_CONVERSATION_TRANSCRIPT = makeConstant('SEND_CONVERSATION_TRANSCRIPT')
export const SEND_CONVERSATION_TRANSCRIPT_SUCCESS = makeConstant('SEND_CONVERSATION_TRANSCRIPT_SUCCESS')
export const SEND_CONVERSATION_TRANSCRIPT_FAILURE = makeConstant('SEND_CONVERSATION_TRANSCRIPT_FAILURE')

export const SET_QUERY = makeConstant('SET_QUERY')
export const SET_COMPOSE_MODAL_STATUS = makeConstant('SET_COMPOSE_MODAL_STATUS')

export const FETCH_ROUTING_AUDIT_LOG = makeConstant('FETCH_ROUTING_AUDIT_LOG')
export const FETCH_ROUTING_AUDIT_LOG_PENDING = makeConstant('FETCH_ROUTING_AUDIT_LOG_PENDING')
export const FETCH_ROUTING_AUDIT_LOG_SUCCESS = makeConstant('FETCH_ROUTING_AUDIT_LOG_SUCCESS')
export const FETCH_ROUTING_AUDIT_LOG_FAILED = makeConstant('FETCH_ROUTING_AUDIT_LOG_FAILED')

export const ConversationSortByProperties = Object.freeze({
  NEWEST: 'Newest',
  OLDEST: 'Oldest',
  LONGEST_WAITING: 'Longest Waiting',
})

export const SELECT_CONVERSATION = makeConstant('SELECT_CONVERSATION')
export const DESELECT_CONVERSATION = makeConstant('DESELECT_CONVERSATION')
export const SELECT_CONVERSATIONS = makeConstant('SELECT_CONVERSATIONS')
export const DESELECT_CONVERSATIONS = makeConstant('DESELECT_CONVERSATIONS')
export const DESELECT_ALL_CONVERSATIONS = makeConstant('DESELECT_ALL_CONVERSATIONS')

export const MAX_SELECTED_CONVERSATIONS_COUNT = 25

export const UPDATE_CONVERSATIONS = makeConstant('UPDATE_CONVERSATIONS')

export const SET_CONVERSATION_LIMIT = makeConstant('SET_CONVERSATION_LIMIT')
export const SET_CONVERSATION_LIMIT_PENDING = makeConstant('SET_CONVERSATION_LIMIT_PENDING')
export const SET_CONVERSATION_LIMIT_FAILURE = makeConstant('SET_CONVERSATION_LIMIT_FAILURE')
export const SET_CONVERSATION_LIMIT_SUCCESS = makeConstant('SET_CONVERSATION_LIMIT_SUCCESS')

export const FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION')
export const FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING')
export const FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE')
export const FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS = makeConstant('FETCH_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS')

export const UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION')
export const UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_PENDING')
export const UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_FAILURE')
export const UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS = makeConstant('UPDATE_GLOBAL_AUTO_CLOSE_CONFIGURATION_SUCCESS')

export const FETCH_SUGGESTED_ARTICLES = makeConstant('FETCH_SUGGESTED_ARTICLES')
export const FETCH_SUGGESTED_ARTICLES_PENDING = makeConstant('FETCH_SUGGESTED_ARTICLES_PENDING')
export const FETCH_SUGGESTED_ARTICLES_SUCCESS = makeConstant('FETCH_SUGGESTED_ARTICLES_SUCCESS')
export const FETCH_SUGGESTED_ARTICLES_FAILED = makeConstant('FETCH_SUGGESTED_ARTICLES_FAILED')



// WEBPACK FOOTER //
// ./src/scripts/app/modules/conversation/constants.js